import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class HighRangeRateModel {
    constructor() {
        this._highRangeRates = [];
        this.fetchHighRangeRate();
    }

    async fetchHighRangeRate() {
        try {
            const response = await axios.get(`${API_BASE_URL}high-range-rate`);
            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                this._highRangeRates = response.data.data.map(dest => ({
                    name: dest.DESTINATION,
                    rate: dest.RATE
                }));
            } else {
                console.warn("No high-range rates found in API response.");
            }
        } catch (error) {
            console.error("Error fetching high-range rate data:", error);
        }
    }

    findRateByDestination(destination) {
        const foundRate = this._highRangeRates.find(rate => rate.name.toLowerCase() === destination.toLowerCase());
        return foundRate ? foundRate.rate : null;
    }
}

export default new HighRangeRateModel();